<template>
  <el-dialog
    :visible="true"
    :title="title"
    width="800"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <el-form
        ref="customerPriceListForm"
        :model="customerPriceList"
        label-position="top"
        :rules="rules"
      >

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="name"
              label="Név"
            >
              <el-input
                v-model="customerPriceList.name"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="customer_groups"
              label="Vevői csoportok"
            >
              <el-select
                v-model="customerPriceList.customer_groups"
                style="width: 100%;"
                filterable
                multiple
                clearable
                value-key="id"
              >
                <el-option
                  v-for="customerGroup in customerGroups"
                  :key="customerGroup.id"
                  :label="customerGroup.name"
                  :value="customerGroup"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="from"
              label="Érvényesség kezdete"
            >
              <el-date-picker
                v-model="customerPriceList.from"
                type="date"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="from"
              label="Érvényesség vége"
            >
              <el-date-picker
                v-model="customerPriceList.to"
                type="date"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <table
          class="price-list-item-table"
          cellpadding="0"
          cellspacing="0"
        >
          <thead class="price-list-item-table__header">
            <tr>
              <td>
                Termék név
              </td>
              <td>
                Ár
              </td>
              <td></td>
            </tr>
          </thead>
          <table-row
            v-for="(item, index) in customerPriceList.items"
            ref="row"
            :key="item.id || item.key"
            :price-list-item="item"
            :index="index"
            :selected-items="customerPriceList.items"
            @selectedProduct="value => item.product = value"
            @deleteProduct="deleteProduct(index)"
          />
        </table>
      </el-form>
      <div
        class="add-item"
      >
        <el-button
          icon="el-icon-plus"
          size="mini"
          @click="addItem"
        >
          Termék hozzáadása
        </el-button>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="store"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  import TableRow from './DialogTableRow';

  export default {
    components: { TableRow },
    props: ['customerPriceListId', 'type', 'copyFromId'],
    data() {
      return {
        buttonLoading: false,
        loading: false,
        customerPriceList: {
          from: null,
          to: null,
          name: '',
          customer_groups: [],
          items: []
        },
        rules: {
          name: [
            { required: true, message: 'Mező kötelező', trigger: 'change' }
          ],
          customer_groups: [
            { required: true, message: 'Mező kötelező', trigger: 'change' }
          ],
        }
      };
    },
    computed: {
      customerGroups() {
        return this.$store.getters['customerGroup/customerGroups'];
      },
      title() {
        if (this.type === 'add') {
          return 'Új Központi Ár';
        } else if (this.type === 'update') {
          return 'Központi Ár módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      if (!this.customerGroups.length) {
        await this.$store.dispatch('customerGroup/fetchAll');
      }
      if (this.type === 'update') {
        this.customerPriceList = await this.$store.dispatch('customerPriceList/fetch', this.customerPriceListId);
        this.customerPriceList.isForCopy = false;
      }
      if(this.type === 'add' && this.copyFromId) {
        this.customerPriceList = await this.$store.dispatch('customerPriceList/fetch', this.copyFromId);
        this.customerPriceList.isForCopy = true;
      }
      this.loading = false;
    },
    methods: {
      addItem() {
        this.customerPriceList.items.push({
          key: Math.random().toString(36).substring(7),
          product: {},
          price: null,
          nowAdded: true,
        });
      },
      deleteProduct(index) {
        this.customerPriceList.items.splice(index, 1);
      },
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/data/customer-price-lists');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs['customerPriceListForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            let priceListItems = [];
            let hasError = false;
            this.$refs.row.forEach(row => {
              if(!row.checkPriceValue() || !row.checkProductValue()) {
                hasError = true;
              } else {
                priceListItems.push(row.item);
              }
            });
            if(!hasError) {
              this.customerPriceList.items = priceListItems;
              try {
                if(this.type === 'add') {
                  await this.$store.dispatch('customerPriceList/create', this.customerPriceList);
                } else {
                  await this.$store.dispatch('customerPriceList/update', this.customerPriceList);
                }
                this.$router.replace('/data/customer-price-lists');
                this.$store.dispatch('customerPriceList/fetchAll');
              } catch (e) {
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    }
  };


</script>
<style
  lang="scss">

  $borderColor: #EBEEF5;
  $headerColor: #909399;

  .price-list-item-table {
    border-left: 1px solid $borderColor;
    border-top: 1px solid $borderColor;
    width: 100%;

    td {
      border-right: 1px solid $borderColor;
      border-bottom: 1px solid $borderColor;
      padding: 12px 10px;
      margin-bottom: -1px;
      vertical-align: top;
    }

    .price-list-item-table__header {
      color: $headerColor;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .add-item {
    border-bottom: 1px dotted #dadfe7;
    border-left: 1px dotted #dadfe7;
    border-right: 1px dotted #dadfe7;
    text-align: center;
    padding: 10px;
  }
</style>
